import { render, staticRenderFns } from "./SportsSingleQTV.vue?vue&type=template&id=377c71ac&scoped=true"
import script from "./SportsSingleQTV.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportsSingleQTV.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SportsSingleQTV.vue?vue&type=style&index=0&id=377c71ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377c71ac",
  null
  
)

export default component.exports